import { createActions } from "redux-actions";

export enum WorkDocumentsActionsType {
  GET_WORK_DOCUMENTS_INFO = "GET_WORK_DOCUMENTS_INFO",
  GET_WORK_DOCUMENTS_INFO_SUCCESS = "GET_WORK_DOCUMENTS_INFO_SUCCESS",
  GET_WORK_DOCUMENTS_INFO_FAILURE = "GET_WORK_DOCUMENTS_INFO_FAILURE",
  GET_WORK_DOCUMENTS_INFO_IDLE = "GET_WORK_DOCUMENTS_INFO_IDLE",
}

const { getWorkDocumentsInfo, getWorkDocumentsInfoSuccess, getWorkDocumentsInfoFailure, getWorkDocumentsInfoIdle } =
  createActions(
    WorkDocumentsActionsType.GET_WORK_DOCUMENTS_INFO,
    WorkDocumentsActionsType.GET_WORK_DOCUMENTS_INFO_SUCCESS,
    WorkDocumentsActionsType.GET_WORK_DOCUMENTS_INFO_FAILURE,
    WorkDocumentsActionsType.GET_WORK_DOCUMENTS_INFO_IDLE
  );

export { getWorkDocumentsInfo, getWorkDocumentsInfoSuccess, getWorkDocumentsInfoFailure, getWorkDocumentsInfoIdle };
